import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

// Layouts
import {LogInComponent} from './Core/Login/login.component';
import {SingleSignOnComponent} from './Core/Login/sso.component';
import {RoutingComponent} from './Core/Routes/routing.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'menu/home',
    pathMatch: 'full',
  },
  // WbLogin (Single Sign On)
  {
    path: 'sso',
    component: SingleSignOnComponent,
  },
  // DbLogin (default)
  {
    path: 'login',
    component: LogInComponent,
  },

  {path: '**', component: RoutingComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
